import React from 'react';
// components
import Iconify from '../../../../components/Iconify';
// ----------------------------------------------------------------------
import EventIcon from '@mui/icons-material/Event';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import PeopleIcon from '@mui/icons-material/People';
import ArticleIcon from '@mui/icons-material/Article';
import GavelIcon from '@mui/icons-material/Gavel';
import LockIcon from '@mui/icons-material/Lock';
import SchoolIcon from '@mui/icons-material/School';
import FolderIcon from '@mui/icons-material/Folder';
import DescriptionIcon from '@mui/icons-material/Description';
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import { Stack } from '@mui/material';

const navConfig = {
  subheader: 'general',
  managerItems: [
    { title: 'Szablony dokumentów', path: '/manager/template-documents', icon: <DescriptionIcon /> },
    { title: 'Pracownicy', path: '/manager/employees-table', icon: <PeopleIcon /> },
    { title: 'Dokumenty Organizacyjne', path: '/manager/organizational-documents', icon: <FolderIcon /> }
  ],
  staffItems: [
    { title: 'Twoje Dane', path: '/manager', icon: <Iconify icon={'carbon:user-avatar-filled-alt'} width={20} height={20} /> },
    { title: 'Turnusy/Terminy', path: '/manager/camps', icon: <Iconify icon={'tabler:mood-kid'} width={20} height={20} /> },
    { title: 'Sun Active', link: 'https://sun-sport.pl/pracuj-z-nami/sun-active/', icon: <WbSunnyIcon /> },
    { title: 'Rozliczenia', path: '/manager/settlements', icon: <EventIcon /> },
    { title: <Stack direction="column"><p>Dokumenty Personalne</p><p>(Uzupełnij)</p></Stack>, path: '/manager/personal-documents', icon: <ArticleIcon />, color: 'rgb(255, 95, 31)' },
    { title: <Stack direction="column"><p>Standardy Pracy</p><p>(Zapoznaj się)</p></Stack>, path: '/manager/work-standards', icon: <GavelIcon />, color: 'rgb(12, 175, 255)' },
    { title: <Stack direction="column"><p>Ochrona danych osobowych</p><p>(Zapoznaj się)</p></Stack>, path: '/manager/personal-data-protection-documents', icon: <LockIcon />, color: 'rgb(12, 175, 255)' },
    { title: <Stack direction="column"><p>Instrukcje organizacji obozów</p><p>(Zapoznaj się)</p></Stack>, path: '/manager/organizing-camps-instruction-documents', icon: <SchoolIcon />, color: 'rgb(12, 175, 255)' },
    { title: <Stack direction="column"><p>Niezbędniki</p><p>(Zapoznaj się)</p></Stack>, path: '/manager/essential-documents', icon: <FileCopyIcon />, color: 'rgb(12, 175, 255)' },
    { title: 'Dokumenty Dodatkowe', path: '/manager/additional-documents', icon: <DescriptionIcon /> }
  ],
  paths: [
    '/manager',
    '/manager/camps',
    '/manager/sun-active-points',
    '/manager/settlements',
    '/manager/personal-documents',
    '/manager/work-standards',
    '/manager/personal-data-protection-documents',
    '/manager/organizing-camps-instruction-documents',
    '/manager/essential-documents',
    '/manager/template-documents',
    '/manager/additional-documents',
    '/manager/employees-table',
    '/manager/organizational-documents'

  ]
};

export default navConfig;
